<div class="ss" [class.ss--open]="isOpen" [class.ss--disabled]="disabled">
  <button type="button" class="field__control ss__trigger" (click)="toggle()" [disabled]="disabled">
    <span class="ss__value" [class.ss__placeholder]="!selectedLabel">{{ selectedLabel || placeholder }}</span>
    <i class="las la-angle-down ss__caret"></i>
  </button>

  @if (isOpen) {
    <div class="ss__panel">
      <input type="text" class="ss__search" #searchInput [placeholder]="searchPlaceholder" [value]="searchTerm"
        (input)="onSearch($event)" (click)="$event.stopPropagation()">
      <ul class="ss__options">
        @for (item of filteredItems; track item) {
          <li class="ss__option" [class.ss__option--selected]="isSelected(item)"
            [class.ss__option--disabled]="isDisabled(item)" (click)="select(item)">
            @if (multiple) {
              <span class="ss__check" [class.ss__check--on]="isSelected(item)"></span>
            }
            {{ getLabel(item) }}
          </li>
        }
        @if (filteredItems.length === 0) {
          <li class="ss__option ss__option--empty">No results</li>
        }
      </ul>
    </div>
  }
</div>
